import React, { Component } from 'react';
import { slide as BurgerMenu } from 'react-burger-menu';

import './Menu.css';

class Menu extends Component {
  constructor(props) {
    super(props);

    this.setOpenState = this.setOpenState.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);

    this.state = {
      isOpen: false,
    };
  }

  setOpenState(state) {
    this.setState({ isOpen: state.isOpen });
  }

  toggleOpen() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    const { dark, hideLabel, sections, currentSlide } = this.props;
    var styles = {
      bmMenu: {
        background: '#ffffff',
        padding: '10px 0 0 0',
        fontSize: '24px',
        fontWeight: '300',
        fontFamily: "'Open Sans', Helvetica, sans-serif",
        zIndex: '10',
      },
      bmCrossButton: {
        height: '36px',
        width: '36px',
      },
      bmCross: {
        background: '#bdc3c7',
      },
      bmMorphShape: {
        fill: '#373a47',
      },
      bmItemList: {
        padding: '1em 1em',
      },
      bmOverlay: {
        background: 'rgba(0, 0, 0, 0.3)',
      },
    };

    let currentSection;
    for (let j = sections.length - 1; j >= 0; j--) {
      if (sections[j].start <= currentSlide) {
        currentSection = sections[j];
        break;
      }
    }

    return (
      <div className={dark ? 'dark menu-container' : 'menu-container'}>
        <BurgerMenu
          styles={styles}
          width={250}
          customBurgerIcon={false}
          isOpen={this.state.isOpen}
          onStateChange={this.setOpenState}
        >
          {sections.map(section => (
            <a
              key={section.name}
              className={
                currentSection === section
                  ? 'sidebar-link active'
                  : 'sidebar-link'
              }
              onClick={e => {
                e.preventDefault();
                this.setState({ isOpen: false });
                Reveal.slide(section.start); // eslint-disable-line
              }}
            >
              {section.name}
            </a>
          ))}
        </BurgerMenu>
        <div onClick={this.toggleOpen} className="top-left">
          <div className="icon-container">
            <img
              className="icon"
              width="26px"
              height="24px"
              alt="Sections menu"
              src={
                dark
                  ? require('../media/menu_dark_gray.png')
                  : require('../media/menu_white.png')
              }
            />
          </div>
          <div className="section-label">
            {hideLabel ? '' : currentSection.name}
          </div>
        </div>
      </div>
    );
  }
}

Menu.propTypes = {
  currentSlide: React.PropTypes.number.isRequired,
  sections: React.PropTypes.array.isRequired,
  dark: React.PropTypes.bool,
  hideLabel: React.PropTypes.bool,
};

export default Menu;



/** WEBPACK FOOTER **
 ** ./src/Menu.js
 **/